module.exports = __webpack_public_path__ + "static/media/global.d3638586.less";